const Games = () => import(/* webpackPrefetch: true, webpackChunkName: 'games' */ 'wap/views/games/App.vue')
const CasinoDetail = () => import(/* webpackPrefetch: true, webpackChunkName: 'games' */ 'wap/views/games/CasinoDetail.vue')

const title = 'Casino Games | MSport'

const routes = [
  {
    path: '/games/detail',
    name: 'casinoDetail',
    component: CasinoDetail,
    meta: {
      hideHeader: true,
      // 无 user 订阅推送
      noPush: true,
      title
    }
  },
  {
    path: '/games',
    name: 'games',
    component: Games,
    meta: {
      requiresFirstNavs: true,
      enableTheme: true,
      title
    }
  }
]

export default routes
